'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import React from 'react';
import ProgressBar from './ProgressBar';
import Score from './Score';

var PageScore = /*#__PURE__*/function (_React$Component) {
  _inherits(PageScore, _React$Component);

  function PageScore() {
    _classCallCheck(this, PageScore);

    return _possibleConstructorReturn(this, _getPrototypeOf(PageScore).apply(this, arguments));
  }

  _createClass(PageScore, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          score = _this$props.score,
          overallScore = _this$props.overallScore;
      var scorePercentage = score / overallScore * 100;
      return /*#__PURE__*/_jsxs(Score, {
        scorePercentage: scorePercentage,
        children: [/*#__PURE__*/_jsxs("div", {
          className: "score",
          children: [score, /*#__PURE__*/_jsxs("span", {
            className: "overall",
            children: ["/", overallScore]
          })]
        }), /*#__PURE__*/_jsx(ProgressBar, {
          scorePercentage: scorePercentage
        })]
      });
    }
  }]);

  return PageScore;
}(React.Component);

PageScore.propTypes = {
  score: PropTypes.number.isRequired,
  overallScore: PropTypes.number.isRequired
};
export { PageScore as default };